import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isFetching: false,
  data: null,
  success: '',
  isSuccess: false,
};

export default function assignPartsStore(state = initialState, action) {
  switch (action.type) {
    case actionConstants.INVENTORY_ASSIGN_PARTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        data: action.payload,
        success: action.message,
      };
    case actionConstants.INVENTORY_ASSIGN_PARTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.message
      };

    case actionConstants.INVENTORY_ASSIGN_PARTS_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case actionConstants.INVENTORY_ASSIGN_PARTS_RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
